const readMoreContentWrapper = document.querySelector('.umbraco-forms-wysiwyg__read-more');
if (readMoreContentWrapper) {

    const button = document.querySelector('.umbraco-forms-form__text-button--read-more');

    // Function to show the content
    const show = (elem) => {

        const height = elem.scrollHeight; // Get the natural height

        elem.classList.add('is-visible'); // Make the content visible
        elem.style.height = height + 'px'; // Update the max-height

        // Once the transition is complete, remove the inline height so the content can scale responsively
        window.setTimeout(function () {
            elem.style.height = '';
        }, 350);

    };

    // Function to hide the content
    const hide = (elem) => {

        // Give the content a height to change from
        elem.style.height = elem.scrollHeight + 'px';

        // Set the height back to 0
        window.setTimeout(function () {
            elem.style.height = '300px';
        }, 1);

        // When the transition is complete, hide it
        window.setTimeout(function () {
            elem.classList.remove('is-visible');
        }, 350);

    };

    // Function to toggle content visibility
    const toggle = (elem) => {

        // If the content is visible, hide it
        if (elem.classList.contains('is-visible')) {
            hide(elem);
            button.innerText = 'Read the summary';
            return;
        }

        // Otherwise, show it
        show(elem);
        button.innerText = 'Hide the summary';

    };

    button.addEventListener('click', (event) => {

        event.preventDefault();

        if (!readMoreContentWrapper) return;

        // Toggle the content
        toggle(readMoreContentWrapper);

    });

}



